import { t } from '../i18n'

export const withLogin = (action, currentUser, openModal, closeModal) => {
  if (currentUser) action()
  else
    openModal({
      name: 'SignIn',
      props: {
        onClose: () => {
          closeModal()
          action()
        }
      },
      modalTitle: t('Sign In')
    })
}
